module.exports = __webpack_public_path__ + "img/signout.01016e93.svg";